import { type ErrorDebugResultProperties, ErrorDebugResult as ErrorDebugResultRc } from '@pba/react-components';
import { useGetErrorDetails } from './hooks';

type P = ErrorDebugResultProperties;

const ErrorDebugResult = ({ additionalData, ...properties }: P) => {
  const getErrorDetails = useGetErrorDetails();

  return <ErrorDebugResultRc additionalData={[...getErrorDetails(), ...(additionalData ?? [])]} {...properties} />;
};

export default ErrorDebugResult;
